// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2aDg5","title":"AfterBackImages_title__3w4S6","images":"AfterBackImages_images__19FZT"};